import { PCT_CALC_TYPES } from '@/md/entities/progProd/progProdCalcTypeUtils';
import { useMemo } from 'react';

// Concession holds a percent, a contract price or a per-unit amount depending on the Calculation Type
export const PriceResConcCellRenderer = ({ value, colDef, data }) => {
  const isPct = PCT_CALC_TYPES.includes(data?.progProdCalcType);

  const formatter = useMemo(() => {
    if (isPct) {
      // Percents are stored as decimals, so scaling to whole percent frees up two of the decimal places
      return new Intl.NumberFormat('en-US', { maximumFractionDigits: Math.max(colDef.decimalPrecision - 2, 0) });
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: colDef.decimalPrecision,
    });
  }, [isPct, colDef.decimalPrecision]);

  if (value == null) {
    return <span />;
  }

  const text = isPct ? formatter.format(value * 100) + '%' : formatter.format(value);

  return <span style={{ display: 'flex', justifyContent: 'flex-end' }}>{text}</span>;
};
